import { IGoalActionTypes, IGoalsListState } from "models/IGoalsState";

const initialState: IGoalsListState = {
  company_goals_data: [],
  team_goals_data: [],
  subteam_goals_data: [],
  individual_goals_data: [],
  task_details: [],
};

const reducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case IGoalActionTypes.FETCH_COMPANY_GOALS_REQUEST:
      return {
        ...state,
        company_goals_data: [],
      };
    case IGoalActionTypes.FETCH_COMPANY_GOALS_SUCCESS:
      return {
        ...state,
        company_goals_data: { ...payload.data },
      };

    case IGoalActionTypes.FETCH_TEAM_GOALS_REQUEST:
      return {
        ...state,
        team_goals_data: [],
      };
    case IGoalActionTypes.FETCH_TEAM_GOALS_SUCCESS:
      return {
        ...state,
        team_goals_data: { ...payload.data },
      };

    case IGoalActionTypes.FETCH_SUBTEAM_GOALS_REQUEST:
      return {
        ...state,
        subteam_goals_data: [],
      };
    case IGoalActionTypes.FETCH_SUBTEAM_GOALS_SUCCESS:
      return {
        ...state,
        subteam_goals_data: { ...payload.data },
      };

    case IGoalActionTypes.FETCH_INDIVIDUAL_GOALS_REQUEST:
      return {
        ...state,
        individual_goals_data: [],
      };
    case IGoalActionTypes.FETCH_INDIVIDUAL_GOALS_SUCCESS:
      return {
        ...state,
        individual_goals_data: { ...payload.data },
      };
    case IGoalActionTypes.FETCH_TASKS_REQUEST:
      return {
        ...state,
        task_details: [],
      };
    case IGoalActionTypes.FETCH_TASKS_SUCCESS:
      return {
        ...state,
        task_details: [...payload.data],
      };
    default:
      return state;
  }
};

export default reducer;
